// Compare strings in a "natural" way: numbers < letters, numeric tokens by value
const collator = new Intl.Collator('en', { sensitivity: 'base', numeric: true });

const tokenize = (s: string) =>
    (s ?? '')
        .trim()
        .split(/\s+/)
        .map((t) => {
            // Accept integers and decimals with . or ,
            const m = t.match(/^-?\d+(?:[.,]\d+)?$/);
            return {
                raw: t,
                num: m ? parseFloat(t.replace(',', '.')) : null,
            };
        });

export const smartCompare = (a = '', b = '') => {
    const ta = tokenize(a);
    const tb = tokenize(b);
    const len = Math.min(ta.length, tb.length);

    for (let i = 0; i < len; i++) {
        const A = ta[i],
            B = tb[i];
        const aNum = A.num !== null,
            bNum = B.num !== null;

        if (aNum && bNum) {
            if (A.num! !== B.num!) return A.num! - B.num!;
        } else if (aNum !== bNum) {
            // Numeric token comes before alpha token
            return aNum ? -1 : 1;
        } else {
            const c = collator.compare(A.raw, B.raw);
            if (c !== 0) return c;
        }
    }
    // All shared tokens equal -> shorter comes first
    if (ta.length !== tb.length) return ta.length - tb.length;

    // Final fallback
    return collator.compare(a, b);
};
